import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import { DescriptionList } from "ant-design-pro";
import * as R from "ramda";
import { Tunnel } from "react-tunnels";

import { countryIsoCodeToName } from "../../../formatters";

const getEntityType = (entity, entitySchema) => {
    const entityTypes = R.pathOr(
        [],
        ["properties", "entityType", "options"],
        entitySchema
    );
    return R.pathOr(
        "",
        ["label"],
        R.find(R.propEq("value", entity.entityType))(entityTypes)
    );
};

const getCountryName = entity => {
    const countryCode = R.pathOr(
        "",
        [
            entity.entityType === "ORGANISATION"
                ? "legalAddress"
                : "physicalAddress",
            "countryCode",
        ],
        entity
    );
    return countryIsoCodeToName(countryCode);
};

const ContinuousMonitoringTitle = ({ entitySchema, entity }) => {
    const entityTypeLabel = getEntityType(entity, entitySchema);
    const countryName = getCountryName(entity);
    return (
        <Tunnel id="bluebar-title">
            <Row type="flex">
                <Col span={6} style={{ marginTop: "0.8em", fontSize: "0.8em" }}>
                    <Link to="/tickets">Back</Link>
                </Col>
                <Col span={18}>
                    <div>{entity.name}</div>
                    <DescriptionList
                        size="small"
                        gutter={24}
                        col={2}
                        style={{ fontSize: "12px" }}
                    >
                        <DescriptionList.Description term="Type">
                            {entityTypeLabel}
                        </DescriptionList.Description>
                        <DescriptionList.Description term="Country">
                            {countryName}
                        </DescriptionList.Description>
                    </DescriptionList>
                </Col>
            </Row>
        </Tunnel>
    );
};

export default ContinuousMonitoringTitle;
